import { Directive, ElementRef, HostListener, inject } from '@angular/core';

@Directive( {
  selector: '[dynamicaNumbersValidation]',
  standalone: true
} )
export class NumbersValidationDirective {
  
  private el = inject(ElementRef);

  // Allow decimal numbers and negative values
  #regex = new RegExp( /^\d*\.?\d*$/ );
  // Allow key codes for special events. Reflect :
  // Backspace, tab, end, home
  #specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];

  @HostListener( 'keydown', ['$event'] )
  onKeyDown( event: KeyboardEvent ) {
    // Allow Backspace, tab, end, and home keys
    if( this.#specialKeys.indexOf( event.key ) !== -1 ) {
      return;
    }

    // This condition because we are using decimal pipe (removing the comma to get the pure number)
    const current: string = this.el.nativeElement.value.includes( ',' )
      ? this.el.nativeElement.value.split( ',' ).join( '' )
      : this.el.nativeElement.value;
    const position = this.el.nativeElement.selectionStart;
    const next: string = [
      current.slice(0, position),
      event.key == 'Decimal' ? '.' : event.key,
      current.slice(position),
    ].join('');

    if( next && !String( next ).match( this.#regex ) ) {
      event.preventDefault();
    }
  }
}
